import { cn } from '@/shared/helpers/classnames'

import { type FC, useContext } from 'react'

import { List as RadixTabsList } from '@radix-ui/react-tabs'

import { TabsContext } from './Tabs'
import type { TabsCellsProps } from './types'

/**
 * Tabs list (Triggers)
 */
export const TabsCells: FC<TabsCellsProps> = ({ children }) => {
  const { variant } = useContext(TabsContext)

  return (
    <RadixTabsList className={cn('tabs-list', `tabs-list-variant-${variant}`)}>
      {children}
    </RadixTabsList>
  )
}

TabsCells.displayName = 'TabsCells'
